import React, { useState } from 'react';

const TaxRegimeComparison: React.FC = () => {
  const [income, setIncome] = useState<number>(0);
  const [deductions80C, setDeductions80C] = useState<number>(0);
  const [hraExemption, setHraExemption] = useState<number>(0);
  const [standardDeduction, setStandardDeduction] = useState<number>(50000); // Default for old regime
  const [oldRegimeTax, setOldRegimeTax] = useState<number | null>(null);
  const [newRegimeTax, setNewRegimeTax] = useState<number | null>(null);

  const calculateTax = () => {
    // Simplified tax calculation logic for demonstration
    // This will need to be expanded with actual tax slabs and rules for both regimes
    let taxableIncomeOld = income - standardDeduction - deductions80C - hraExemption;
    if (taxableIncomeOld < 0) taxableIncomeOld = 0;

    let taxableIncomeNew = income; // New regime has very few deductions

    // Placeholder tax calculation (replace with actual slabs)
    const calculateTaxAmount = (taxableAmount: number) => {
      if (taxableAmount <= 250000) return 0;
      if (taxableAmount <= 500000) return (taxableAmount - 250000) * 0.05;
      if (taxableAmount <= 1000000) return 12500 + (taxableAmount - 500000) * 0.20;
      return 112500 + (taxableAmount - 1000000) * 0.30;
    };

    setOldRegimeTax(calculateTaxAmount(taxableIncomeOld));
    setNewRegimeTax(calculateTaxAmount(taxableIncomeNew));
  };

  return (
    <div className="tax-regime-comparison-container">
      <h2>Tax Regime Comparison (Old vs. New)</h2>
      <p>Enter your financial details to compare tax under both regimes.</p>

      <div className="input-group">
        <label>
          Gross Annual Income:
          <input
            type="number"
            value={income}
            onChange={(e) => setIncome(parseFloat(e.target.value))}
          />
        </label>
      </div>

      <div className="input-group">
        <label>
          80C Deductions (e.g., PPF, ELSS):
          <input
            type="number"
            value={deductions80C}
            onChange={(e) => setDeductions80C(parseFloat(e.target.value))}
          />
        </label>
      </div>

      <div className="input-group">
        <label>
          HRA Exemption:
          <input
            type="number"
            value={hraExemption}
            onChange={(e) => setHraExemption(parseFloat(e.target.value))}
          />
        </label>
      </div>

      <div className="input-group">
        <label>
          Standard Deduction (Old Regime):
          <input
            type="number"
            value={standardDeduction}
            onChange={(e) => setStandardDeduction(parseFloat(e.target.value))}
          />
        </label>
      </div>

      <button onClick={calculateTax}>Calculate Tax</button>

      {oldRegimeTax !== null && newRegimeTax !== null && (
        <div className="results">
          <h3>Results:</h3>
          <p>Tax under Old Regime: ₹{oldRegimeTax.toFixed(2)}</p>
          <p>Tax under New Regime: ₹{newRegimeTax.toFixed(2)}</p>
          {oldRegimeTax < newRegimeTax ? (
            <p>Old Regime is more beneficial by ₹{(newRegimeTax - oldRegimeTax).toFixed(2)}</p>
          ) : (
            <p>New Regime is more beneficial by ₹{(oldRegimeTax - newRegimeTax).toFixed(2)}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default TaxRegimeComparison;
